import React, { FC } from 'react'
import { graphql, useFragment } from 'react-relay'

import { UserItem } from '../User/UserItem'
import { GuildItem } from '../Guild/GuildItem'

import { ActorItem_actor$key } from './__generated__/ActorItem_actor.graphql'

export const ActorItem: FC<{
  actor: ActorItem_actor$key
  displayMyRelationStatus?: boolean
  textSize?: number
  photoSize?: number
  nameOnly?: boolean
}> = ({ actor, displayMyRelationStatus, textSize, photoSize, nameOnly }) => {
  const data = useFragment(
    graphql`
      fragment ActorItem_actor on Actor
      @argumentDefinitions(
        displayMyRelationStatus: { type: "Boolean!", defaultValue: true }
      ) {
        __typename

        ... on User {
          ...UserItem_user
            @arguments(displayFollowingMessage: $displayMyRelationStatus)
        }

        ... on Guild {
          ...GuildItem_guild
            @arguments(displayMembershipStatus: $displayMyRelationStatus)
        }
      }
    `,
    actor
  )

  if (data.__typename === 'Guild') {
    return (
      <GuildItem
        guild={data}
        displayMembershipStatus={displayMyRelationStatus}
        textSize={textSize}
        photoSize={photoSize}
        nameOnly={nameOnly}
      />
    )
  }

  if (data.__typename === 'User') {
    return (
      <UserItem
        user={data}
        displayFollowingMessage={displayMyRelationStatus}
        textSize={textSize}
        photoSize={photoSize}
      />
    )
  }

  console.error('Unknown ActorItem Typename:', data.__typename)

  return null
}
